import { action, thunk } from "easy-peasy";

export default {
	psi: {},
	urlPath: process.env.NODE_ENV === "development" ? "" : "/wp-content/themes/horizon-mercury/audit-react-app/build",
	addPsi: action((state, payload) => {
		state.psi = payload;
		return state;
	}),
	clearPsi: action((state, payload) => {
		state.psi = {
			"message": "clear"
		};
		return state;
	})
};